<template>
  <div class="home py-5">
    <div v-if="dataLoaded" class="sheet-container">
      <AveineUserSheet :APIbaseURL="APIbaseURL" :consumerAPIbaseURL="consumerAPIbaseURL" :userProfile="userProfile" :isSelf="isSelf" :adminMode="true"/>
      <AveineUserBilling :userId="$route.params.id"/>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineUserSheet } from 'aveine-user'
import AveineUserBilling from '@/components/billing/AveineUserBilling.vue'
import { User, UserProfile } from 'aveine-toolbox';
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      userProfile: {},
      userFollows: [],
      userFollowers: [],
      userFollowable: false,
      userFollowed: false,
      dataLoaded: false,
      isSelf: true,
      APIbaseURL: process.env.VUE_APP_API_HOST,
      consumerAPIbaseURL: process.env.VUE_APP_API_CONSUMER_HOST
    }
  },
  components: {
    AveineUserSheet,
    AveineUserBilling
  },
  name: 'Read',
  methods: {
    async loadData() {
      try {
        this.authToken = await this.$auth.getTokenSilently();
        const userProfileReq = await User.api().get(`/users/${this.$route.params.id}?lang=${this.$i18n.locale}`,{
          baseURL: this.APIbaseURL,
          params: {
            include: "profile"
          }
        });

        this.userProfile = await UserProfile.query().whereId(userProfileReq.entities.user_profiles[0].$id).withAllRecursive().first();

        if (this.$route.params.id == this.$auth.loggedUserId) {
          this.isSelf = true
        }

        let userStatsReq = await fetch(`${this.APIbaseURL}/users/${this.$route.params.id}/stats`, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ` + this.authToken
          }
        })

        let userStats = await userStatsReq.json();

        this.userProfile.scan_count = userStats["scan-count"]
        this.userProfile.favorite_count = userStats["favorite-count"]
        this.userProfile.comment_count = userStats["comment-count"]
        this.userProfile.wine_form_count = userStats["wine-form-count"]

        let followedReq = await UserProfile.api().get(`/users/${this.$route.params.id}/follows`, {
          baseURL: this.APIbaseURL,
        })

        followedReq.response.data.map(async (follow) => {
          this.userFollows.push(await UserProfile.query().whereId(follow.id).withAllRecursive().first());
        });
        
        let userFollowStatsReq = await fetch(`${this.APIbaseURL}/users/${this.$route.params.id}/follows/count`, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ` + this.authToken
          }
        })

        let userFollowStats = await userFollowStatsReq.json();
        this.userProfile.follow_count = userFollowStats["follow-count"]
        this.userProfile.follower_count = userFollowStats["follower-count"]

        this.dataLoaded = true;
      } catch (errors) {
        this.dataLoaded = true;
        errorHandler(errors, this)
      }
    }
  },
  async created() {
    this.loadData()
  },
}
</script>


